angular
.module('jv.candidate.invite.reviewers.video.modal.controller',[])
.controller('CandDetailsInviteReviewersVideoModalCtrl',['$scope', 'videoService', '$rootScope', '$routeParams',
    function($scope, videoService, $rootScope, $routeParams){
    $scope.isNewJQuery = parseFloat(jQuery.fn.jquery) > 1.7;
    // formResponseId
    var formId = null;
    $scope.parent = {};
    //This is expecting String[] userEIds, Date deadline, String subject, and String message.
    $scope.parent.messageTpl=null;
    $scope.formObject = {};
    $scope.selectedTemplate = null;
    var appId = $routeParams.applicationId;

    $scope.inviteReviewers = function(){
        $scope.formObject.id = formId;
        $scope.flags.loading = true;
        var args = {};
        args.formObj = $scope.formObject;
        args.appId = appId;
        videoService.inviteReviewers(args, function(result){
            // result came back
            $scope.flags.loading = false;
            if(angular.isUndefined(result.error)||result.error===null){
                // close the overlay.
                $scope.modal.inviteReviewerModal=false;
                $scope.flags.loading = true;
                $rootScope.$broadcast('REFRESH_VIDEO_LIST');
            }
        });
    };

     var selectDefaultTemplate = function(templates){
        angular.forEach(templates, function(tpl) {
            if (tpl['default']) {
                $scope.selectedTemplate = tpl;
                $scope.formObject.message = tpl.body;
                $scope.formObject.subject = tpl.subject;
            }
        });
        return templates;
    };

    var setModal = function( results ){
        $scope.flags.loading = true;
        //selectedEmployees array
        var selectedEmployees = [ ];
        angular.forEach(results.resultList, function(value){
            selectedEmployees.push(value.userEId);
        });
        $scope.formObject.userEIds= selectedEmployees;
        videoService.inviteMessageTemplate({
            formResponseId: formId
        }, function(results){
            $scope.parent.messageTpl = selectDefaultTemplate($scope.select2Options.setTemplates(results.resultList));
        });
        $scope.flags.loading = false;
    };

    $scope.$watch('selectedTemplate', function(newValue){
        if(angular.isDefined(newValue) && newValue!==null){
            $scope.formObject.message = newValue.body;
            $scope.formObject.subject = newValue.subject;
        }

    });

    $scope.$on('SHOW_VIDEO_INVITE', function(event, formID, id){
        formId=formID;
        appId = id;
        setModal({resultList:[]});
        return;
        // VA: we do not want to show the invited reviewers now.
        // videoService.invitedUsers({
        //     "id":formId
        // }, function(results){
        //     setModal( results );
        // });
    });

}]);